export const playbooksPath = 'api/landlord/automations';